import { loginApi } from '../../setup/setupApi';
import {
  ConnectorValues,
  ConnectProps,
  CustomScopesResponse,
  PutCustomScopes,
  SocialConnectionsResponse
} from './types';

export const getSocialConnections = (projectId: string): Promise<SocialConnectionsResponse> =>
  loginApi.get(`projects/${projectId}/social`).then((res) => res.data);

export const setSocialConnections = ({
  projectId,
  provider,
  values
}: ConnectProps): Promise<boolean | ConnectorValues> =>
  loginApi.post(`projects/${projectId}/social/${provider}`, values).then((res) => res.data);

export const updateSocialConnections = ({
  projectId,
  provider,
  values
}: ConnectProps): Promise<boolean | ConnectorValues> =>
  loginApi.put(`projects/${projectId}/social/${provider}`, values).then((res) => res.data);

export const deleteSocialConnections = (projectId: string, provider: string): Promise<boolean> =>
  loginApi.delete(`projects/${projectId}/social/${provider}`).then((res) => res.data);

export const connectSocialConnectionsList = (
  projectId: string,
  socialList: SocialConnectionsResponse
): Promise<(boolean | ConnectorValues)[]> => {
  return Promise.all(
    socialList.map((social) => {
      return setSocialConnections({
        projectId,
        provider: social.provider,
        values: {
          client_id: social.configurable_fields[0].value,
          client_secret: social.configurable_fields[1].value,
          one_tap_login: { enabled: !!social.one_tap_login?.enabled }
        }
      });
    })
  );
};

export const disconnectSocialConnectionsList = (
  projectId: string,
  socialList: SocialConnectionsResponse
): Promise<boolean[]> => {
  return Promise.all(
    socialList.map((social) => deleteSocialConnections(projectId, social.provider))
  );
};

export const getCustomScopes = (
  projectId: string,
  providerName: string
): Promise<CustomScopesResponse> =>
  loginApi.get(`/projects/${projectId}/social/${providerName}/settings`).then((res) => res.data);

export const putCustomScopes = ({
  projectId,
  providerName,
  custom_scope,
  refresh_always
}: PutCustomScopes): Promise<never> =>
  loginApi.put(`/projects/${projectId}/social/${providerName}/custom_scope`, {
    custom_scope,
    refresh_always
  });
